import { render } from "./BioSection.vue?vue&type=template&id=183233cc&scoped=true"
import script from "./BioSection.vue?vue&type=script&lang=js"
export * from "./BioSection.vue?vue&type=script&lang=js"

import "./BioSection.vue?vue&type=style&index=0&id=183233cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183233cc"]])

export default __exports__